import { Component, OnInit, Input } from '@angular/core';
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss']
})
export class ProgressCircleComponent implements OnInit {
  public points:number = 0;
  public required:number = 0;
  public progress:number = 0;
  @Input('stroke') stroke: number = 45;
  @Input('width') width: number = 70;
  @Input('height') height: number = 70;
  @Input('innerSize') innerSize: number = 60;
  @Input('showTime') showTime: boolean = true;
  constructor(private accountService:AccountService) {
    // this.accountService.recalcUserPoints().subscribe(
    //   res=>{
    //     //console.log(res);
    //   }
    // );
    this.accountService.accountChanged.subscribe(event=>{
      this.update();
    });
    this.update();
  }

  ngOnInit() {

  }

  update(){
    this.points = this.accountService.getCurrentPoints();
    this.required = this.accountService.getLocalAccount().required_points;
    let percent=Math.floor((100/this.required)*this.points);
    if(percent>100){percent=100;}
    //console.log(this.required, this.points, this.progress);
    this.progress = percent;
  }

}
